/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useLazyQuery, gql } from '@apollo/client';

const TD_AUTH_LOGIN_GQL = gql`
      query Query($code: String!, $redirectParameters: RedirectParameters!) {
        TdUserLoginCode(code: $code, redirectParameters: $redirectParameters) {
          redirectURL
          isExistingUser
          isUserOlder
          isUserEconsentUptoDate
          registeredUserId
        }
      }
  `;

  export const useTdAuthLogin = () => {

    const [getTdUserLoginDetails, tdUserLoginDetail] = useLazyQuery(TD_AUTH_LOGIN_GQL);
  
    return { getTdUserLoginDetails, tdUserLoginDetail };
  };

